import Modal from "../../../Components/Modal/Modal";
import { SettingOutlined } from "@ant-design/icons";
import ModalUI from "./ModalUI";
import { setOptionGreekConstraintFormValues } from "../../../Features/OptionGreek/optionGreekSlice";
import { IOptionGreekConstraintFormValues } from "../../../Interfaces/optionGreek";
import { useAppDispatch } from "../../../App/hooks";
import { useState } from "react";

const Constraint = () => {
  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useAppDispatch();
  const modalCloseHandler = () => {
    setIsOpen(false);
    dispatch(
      setOptionGreekConstraintFormValues({} as IOptionGreekConstraintFormValues)
    );
  };

  return (
    <>
      <div
        className="flex flex-row justify-start items-center w-full gap-3 p-2 border-2 rounded border-gray-300 hover:border-gray-500 transition-all duration-200 cursor-pointer"
        onClick={() => setIsOpen(true)}
      >
        {isOpen ? (
          <Modal UI={<ModalUI />} onClose={modalCloseHandler} />
        ) : (
          <></>
        )}
        <SettingOutlined />
        <div className="text-xs">تنظیمات</div>
      </div>
    </>
  );
};

export default Constraint;
